module.exports = __webpack_public_path__ + "static/media/grayDeposit.78b96e28.svg";